import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Alert } from "react-bootstrap";
import AlertViewModel from "viewModels/alertViewModel";
import Icon, { IconType } from "@edaz/edazkit/Icon";

const alertView: ViewComponent<AlertViewModel> = observer(({ vm }) => {
  let alertContent;
  if (vm.notification.action) {
    // Action title supplied - create link with action title on the right side of alert
    if (vm.notification.action.title) {
      alertContent = (
        <div className="d-flex justify-content-between">
          <span>{vm.notification.title}</span>
          <a href={vm.notification.action.link ?? "#"} onClick={vm.notification.action.func}>
            {vm.notification.action.title}
            <Icon className="align-text-top" icon={IconType.ArrowRight} width={20} height={20} />
          </a>
        </div>
      );
    } else {
      // Action title NOT supplied - create link with as alert's main content
      alertContent = (
        <a href={vm.notification.action.link} onClick={vm.notification.action.func}>
          {vm.notification.title}
        </a>
      );
    }
  } else {
    // Just static alert without any action/link
    alertContent = vm.notification.title;
  }

  return (
    <Alert variant={vm.variant} dismissible={!!vm.onClose} closeLabel="&times;" onClose={vm.onClose}>
      {alertContent}
    </Alert>
  );
});

export default registerView(alertView, AlertViewModel);
